let EditDict = {
  b2b_enabled_status: [
    {
      id: "1008",
      label: "是",
      value: "0",
    },
    {
      id: "1009",
      label: "否",
      value: "1",
    },
  ],
  area_list: [
    {
      id: "小岔乡",
      label: "小岔乡",
    },
    {
      id: "交岔乡",
      label: "交岔乡",
    },
    {
      id: "古城镇",
      label: "古城镇",
    },
    {
      id: "冯庄乡",
      label: "冯庄乡",
    },
    {
      id: "城阳乡",
      label: "城阳乡",
    },
    {
      id: "红河镇",
      label: "红河镇",
    },
    {
      id: "罗洼乡",
      label: "罗洼乡",
    },
    {
      id: "新集乡",
      label: "新集乡",
    },
    {
      id: "王洼镇",
      label: "王洼镇",
    },
    {
      id: "孟塬乡",
      label: "孟塬乡",
    },
    {
      id: "白阳镇",
      label: "白阳镇",
    },
    {
      id: "草庙乡",
      label: "草庙乡",
    },
  ],
  trace_service_status: [
    {
      label: "使用中",
      value: "0",
    },
    {
      label: "已停用",
      value: "1",
    },
  ],
  trace_call_status: [
    {
      label: "失败",
      value: "0",
    },
    {
      label: "正常",
      value: "1",
    },
  ],
  trace_call_method: [
    {
      label: "get",
      value: "0",
    },
    {
      label: "post",
      value: "1",
    },
  ],
  trace_timing_status: [
    {
      label: "否",
      value: "0",
    },
    {
      label: "是",
      value: "1",
    },
  ],
  trace_param_type: [
    {
      label: "最新时间",
      value: "0",
    },
    {
      label: "文本",
      value: "1",
    },
  ],
  "base_certificat":[
		{label:'有机认证基地',value:'0',disable:false},
		{label:'绿色认证基地',value:'1',disable:false},
		{label:'精品示范园',value:'2',disable:false},
		{label:'其他',value:'3',disable:false}
	],
	"base_level":[
		{label:'国家级',value:1},
		{label:'省级',value:2},
		{label:'市级',value:3},
		{label:'县级',value:4},
		{label:'其他',value:5}
	],
	"base_hezuo_type":[
		{label:'种植型',value:1},
		{label:'加工型',value:2},
		{label:'三产融合型',value:3},
		{label:'社会化服务型',value:4}
	],
	"base_plant_type":[
		{label:'合作社',value:1},
		{label:'大户(大于20亩)',value:2},
		{label:'散户',value:3}
	],
	"base_process_type":[
		{label:'去核',value:1},
		{label:'切片',value:2},
		{label:'除杂',value:3},
		{label:'清洗',value:4},
		{label:'其他',value:5}
	],
	"base_social_type":[
		{label:'农机',value:1},
		{label:'农技',value:2},
		{label:'农资',value:3}
	],
    "base_industry_type":[
		{label:'观光园',value:1},
		{label:'采摘园',value:2},
		{label:'民宿',value:3}
	],
  "order_state_type_b2b": [{
		"id": "1061",
		"label": "待确认",
		"value": "0"
	}, {
		"id": "1062",
		"label": "待付款",
		"value": "1"
	}, {
		"id": "1063",
		"label": "待发货",
		"value": "2"
	}, {
		"id": "1064",
		"label": "待收货",
		"value": "3"
	}, {
		"id": "1068",
		"label": "待备货",
		"value": "7"
	}, {
		"id": "1069",
		"label": "待自提",
		"value": "8"
	}, {
		"id": "1065",
		"label": "已完成",
		"value": "4"
	}, {
		"id": "1066",
		"label": "已取消",
		"value": "5"
	}],
	"refund_appl_state_type_b2b": [{
		"id": "1081",
		"label": "待审核",
		"value": "0"
	},  {
		"id": "1084",
		"label": "已完成",
		"value": "3"
	}, {
		"id": "1085",
		"label": "已取消",
		"value": "4"
	},{
		"id": "1083",
		"label": "已拒绝",
		"value": "2"
	},],
  "scene_type":[
		{label:'商通中心门户',value:'10'},
		{label:'1+3保真保质',value:'11'},
		{label:"商城交易",value:'12'},
		
	],
};
module.exports = EditDict;
